import React, { useState } from "react";
import { Key, Plus } from "lucide-react";

/* ===================== COMPONENTS ===================== */
import Button from "../../../components/Button/Button";
import ManageApiTable from "../../../components/AdminComponents/ManageApiTable/ManageApiTable";
import CreateApiCredentials from "../../../components/ApiKeys/CreateApiCredentials";
import LosCredentialsTable from "../../../components/ApiKeys/los/LosCredentialsTable";
import CreateLosCredential from "../../../components/ApiKeys/los/CreateLosCredential";

/* ===================== UTILS ===================== */
import { can } from "../../../utils/permissions";

/* ===================== STYLES ===================== */
import styles from "./ManageApiCredentials.module.scss";

const TABS = ["Marketplace", "LOS"];

const ManageApiCredentials = () => {
  // Granted actions on the "api-keys" resource (from /modules/sidebar)
  const canDo = (action) => can("api-keys", action);

  const [activeTab, setActiveTab] = useState(
    canDo("access-marketplace") ? "Marketplace" : "LOS",
  );
  const [showCreate, setShowCreate] = useState(false);

  const switchTab = (tab) => {
    setActiveTab(tab);
    setShowCreate(false);
  };

  return (
    <div className={styles["admin-manage-api-cred__page"]}>
      {/* TABS */}
      <div className={styles["admin-manage-api-cred__tabs"]}>
        {TABS.map(
          (tab) =>
            canDo(
              tab === "Marketplace" ? "access-marketplace" : "access-los",
            ) && (
              <button
                key={tab}
                className={`${styles["admin-manage-api-cred__tab"]} ${
                  activeTab === tab
                    ? styles["admin-manage-api-cred__tab--active"]
                    : ""
                }`}
                onClick={() => switchTab(tab)}
              >
                {tab}
              </button>
            ),
        )}
      </div>

      {/* MARKETPLACE TAB (default) */}
      {activeTab === "Marketplace" &&
        canDo("access-marketplace") &&
        (showCreate ? (
          <CreateApiCredentials onBack={() => setShowCreate(false)} />
        ) : (
          <>
            <div className={styles["admin-manage-api-cred__header"]}>
              <div className={styles["admin-manage-api-cred__icon-wrapper"]}>
                <Key size={24} strokeWidth={2.5} />
              </div>
              <div className={styles["admin-manage-api-cred__title-group"]}>
                <h2 className={styles["admin-manage-api-cred__title"]}>
                  API Keys
                </h2>
                <p className={styles["admin-manage-api-cred__subtitle"]}>
                  Your Auth 2.0 application credentials.
                </p>
              </div>
              <div className={styles["admin-manage-api-cred__action"]}>
                {canDo("add-marketplace-api-creds") && (
                  <Button
                    icon={Plus}
                    text="Add API Credentials"
                    onClick={() => setShowCreate(true)}
                  />
                )}
              </div>
            </div>
            <ManageApiTable />
          </>
        ))}

      {/* LOS TAB */}
      {activeTab === "LOS" &&
        canDo("access-los") &&
        (showCreate ? (
          <CreateLosCredential isAdmin onBack={() => setShowCreate(false)} />
        ) : (
          <>
            <div className={styles["admin-manage-api-cred__header"]}>
              <div className={styles["admin-manage-api-cred__icon-wrapper"]}>
                <Key size={24} strokeWidth={2.5} />
              </div>
              <div className={styles["admin-manage-api-cred__title-group"]}>
                <h2 className={styles["admin-manage-api-cred__title"]}>
                  LOS Credentials
                </h2>
                <p className={styles["admin-manage-api-cred__subtitle"]}>
                  Manage your LOS API credentials.
                </p>
              </div>
              <div className={styles["admin-manage-api-cred__action"]}>
                {canDo("add-los-creds") && (
                  <Button
                    icon={Plus}
                    text="Add LOS Credential"
                    onClick={() => setShowCreate(true)}
                  />
                )}
              </div>
            </div>
            <LosCredentialsTable isAdmin />
          </>
        ))}
    </div>
  );
};

export default ManageApiCredentials;
